import React from 'react';
import { Row, Descriptions, Table } from 'antd';

import { table } from 'src/utils';

import { IProps } from './step.type';
import { Left, Right } from './step.style';
import { ColumnsType } from 'antd/lib/table';

const StepComponent: React.FC<IProps> = (props) => {
  const { measurements, currentOrder, stepReport, steps } = props;

  const handleColumns = (): ColumnsType<{ key: string; label: string; sizes: any }> => {
    let sizes: string[] = measurements.reduce(
      (previousValue: any, currentValue: any) => {
        let prev: any = previousValue;

        if (!!currentValue.quantity) prev.push(currentValue?.gridSize?.name);

        return prev;
      },
      []
    );

    const columns: ColumnsType<{ key: string; label: string; sizes: any }> =
      sizes?.map((item: any, index: any) => ({
        key: index,
        title: item,
        dataIndex: ['sizes', item],
      })) || [];

    columns.push({
      key: 'total',
      title: 'Total',
      dataIndex: ['sizes', 'total'],
    });

    return [
      {
        key: 'label',
        title: 'Descrição',
        dataIndex: 'label',
        fixed: 'left' as const,
      },
      ...columns,
    ];
  };

  const handleDataSource = () => {
    let orderSizeValues: any = [];
    let quantityPrimaryValues: any = [];
    let quantitySecondaryValues: any = [];
    let lostSizeValues: any = [];

    measurements.map(
      (item: any) => (orderSizeValues[item.gridSize.name] = item.quantity || 0)
    );

    stepReport?.map(
      (item: any) => (quantityPrimaryValues[item.gridSizeName] = item.quantity_1 || 0)
    );

    stepReport?.map(
      (item: any) => (quantitySecondaryValues[item.gridSizeName] = item.quantity_2 || 0)
    );

    stepReport?.map(
      (item: any) => (lostSizeValues[item.gridSizeName] = item.lost_quantity || 0)
    );

    const calculateTotal = (sizes: any) =>
      Object.values(sizes).reduce((sum: number, val: any) => sum + Number(val || 0), 0);

    return [
      { key: 'order', label: 'Pedido', sizes: { ...orderSizeValues, total: calculateTotal(orderSizeValues) } },
      { key: 'quantityPrimary', label: 'Quantidade 1', sizes: { ...quantityPrimaryValues, total: calculateTotal(quantityPrimaryValues) } },
      { key: 'quantitySecondary', label: 'Quantidade 2', sizes: { ...quantitySecondaryValues, total: calculateTotal(quantitySecondaryValues) } },
      { key: 'lost', label: 'Perda', sizes: { ...lostSizeValues, total: calculateTotal(lostSizeValues) } },
    ];
  };

  return (
    <Row gutter={16} className="mt-2">
      <Left span={8}>
        <Descriptions
          style={{ width: '100%' }}
          title={`OC: ${currentOrder?.cutOrder}`}
          bordered
          size={'small'}
          column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
          className="mb-3 oc-description"
        >
          <Descriptions.Item label="Pedido:">
            {currentOrder?.orderNumber}
          </Descriptions.Item>
          <Descriptions.Item label={'Baixa:'}>
            {steps?.find(
              (item: any) =>
                item.id === Number(props.form.getFieldValue(['stepId']))
            )?.name || '-'}
          </Descriptions.Item>
          <Descriptions.Item
              label={stepReport[0].date_type.charAt(0).toUpperCase() + stepReport[0].date_type.slice(1) + ':'}          
          >
            {stepReport?.[0]?.order_date
              ? stepReport[0].order_date
                  .split('-')
                  .reverse()
                  .join('/')
              : '-'}
          </Descriptions.Item>
        </Descriptions>
      </Left>
      <Right span={16}>
        <Table
          {...table}
          bordered
          pagination={false}
          columns={handleColumns()}
          dataSource={handleDataSource()}
          className="mb-3"
        />
      </Right>
    </Row>
  );
};

export default StepComponent;
